import { reactive, toRefs } from 'vue'
import { JSONCodec, connect } from 'nats.ws'
import usePurchase from './purchase.store'

const purchaseStore = usePurchase()

const state = reactive({
  natsServer: null
})

const jsonCodec = JSONCodec()

export default function () {
  async function getNatsServer (natsConfig) {
    if (state.natsServer) return state.natsServer
  
    state.natsServer = await connect({
      servers: [natsConfig.server],
      user: natsConfig.user,
      pass: natsConfig.pass,
    })
  
    return state.natsServer
  }

  async function subscribeNatsServer (natsConfig) {
    const NATS_TOPIC_BASE = import.meta.env.VITE_NATS_TOPIC_BASE
    const NATS_TOPIC_PURCHASE = import.meta.env.VITE_NATS_TOPIC_PURCHASE

    const natsServer = await getNatsServer(natsConfig)
    const sub = natsServer.subscribe(NATS_TOPIC_BASE);

    const listen = async (sub) => {
      for await (const message of sub) {
        const { subject, data } = message

        switch (subject) {
          case NATS_TOPIC_PURCHASE: {
            const payload = jsonCodec.decode(data)
            console.log(`[NATS] NEW ${payload.type} PURCHASE WAS MADE`)

            if (purchaseStore.newPurchases.value[payload.type] <= 99){
              purchaseStore.newPurchases.value[payload.type] ++
            }
            break
          }
          // case NAT
          default:
            break
        }
      }
      console.log('sub closed')
    }

    await listen(sub)
    await natsServer.closed()
  }

  return {
    ...toRefs(state),
    subscribeNatsServer
  }
}